__turbopack_context__.v({
  "cloudCircle": "Cloud-module__L59L8a__cloudCircle",
  "root": "Cloud-module__L59L8a__root",
});
